import { render, staticRenderFns } from "./email_editor.vue?vue&type=template&id=84d1bce2&scoped=true&"
import script from "./email_editor.vue?vue&type=script&lang=js&"
export * from "./email_editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d1bce2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84d1bce2')) {
      api.createRecord('84d1bce2', component.options)
    } else {
      api.reload('84d1bce2', component.options)
    }
    module.hot.accept("./email_editor.vue?vue&type=template&id=84d1bce2&scoped=true&", function () {
      api.rerender('84d1bce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/email/list/email_editor.vue"
export default component.exports